import { useEffect, useMemo, useState } from 'react';

export const useNewsFilter = (
  onClose: () => void,
  selectedTypes: string[],
  onApply: (types: string[]) => void,
  newsTypes?: string[],
) => {
  const [pendingTypes, setPendingTypes] = useState<string[]>(selectedTypes || []);

  useEffect(() => {
    setPendingTypes(selectedTypes || []);
  }, [selectedTypes]);

  const toggleType = (type: string) => {
    setPendingTypes(prev =>
      prev.includes(type) ? prev.filter(x => x !== type) : [...prev, type],
    );
  };

  const apply = () => {
    onApply(pendingTypes);
    onClose();
  };

  const reset = () => {
    setPendingTypes([]);
    onApply([]);
  };

  const chips = useMemo(() => {
    return pendingTypes.map(type => ({
      id: type,
      label: type,
      onRemove: () => toggleType(type),
    }));
  }, [pendingTypes]);

  return {
    state: { pendingTypes, newsTypes },
    controls: { toggleType, apply, reset },
    data: { chips, selectedCount: pendingTypes.length },
  };
};